module.exports = __webpack_public_path__ + "9779d9a1/img/grid-web-icon.d0395d64.svg";